import React from 'react';
import AdmNivoChart from '../adm_executive_view/AdmNivoChart';
import { addSharpTransitions, createLineConfig } from './admChartUtils';

/**
 * Reusable component for rendering interval (non-cumulative) charts for ADM data
 * Supports arrival and/or closure data
 */
export default function AdmIntervalChartWrapper(props) {
  const {
    title,
    arrival,
    closure,
    increment,
    d0_interval,
    d2_interval,
    arrivalColor,
    closureColor,
    chartHeight = '24vw',
    showArrival = true,
    showClosure = true
  } = props;

  // Early return if no data
  if (!arrival && !closure) {
    return null;
  }

  const lines = [];

  // Add Arrival lines if requested
  if (showArrival && arrival) {
    // Arrival Actual
    if (arrival.actual_processed && arrival.actual_processed.length > 0) {
      lines.push(createLineConfig('Arrival (Actual)', arrival.actual_processed, arrivalColor, 'solid', true));
    }

    // Arrival Predicted with sharp transitions
    if (arrival.predicted && arrival.predicted.length > 0) {
      lines.push(createLineConfig('Arrival (Predicted)', addSharpTransitions(arrival.predicted), arrivalColor, 'dashed', true));
    }
  }

  // Add Closure lines if requested
  if (showClosure && closure) {
    // Closure Actual
    if (closure.actual_processed && closure.actual_processed.length > 0) {
      lines.push(createLineConfig('Closure (Actual)', closure.actual_processed, closureColor, 'solid', true));
    }

    // Closure Predicted with sharp transitions
    if (closure.predicted && closure.predicted.length > 0) {
      lines.push(createLineConfig('Closure (Predicted)', addSharpTransitions(closure.predicted), closureColor, 'dashed', true));
    }
  }

  return (
    <AdmNivoChart
      title={title}
      lines={lines}
      rects={[]}
      scatters={[]}
      chartHeight={chartHeight}
      allowHidingLines={true}
      allowHoverTooltip={true}
      xAxisLabel={`Interval (${increment} days)`}
      d0_interval={d0_interval}
      d2_interval={d2_interval}
    />
  );
}
